import { useEffect } from "react";

/**
 * Lightweight SEO hook that updates document title, meta description,
 * canonical URL, and Open Graph tags on route change. No dependencies.
 */
export default function useSEO({ title, description, path, ogImage }) {
  useEffect(() => {
    const fullTitle = title || "Tandem T Holdings LLC";
    const desc =
      description ||
      "Tandem T Holdings LLC — a minority woman-owned holding company delivering logistics, real estate, and government-aligned solutions.";
    const canonical = `https://tandemtholdings.com${path || ""}`;
    const image = ogImage || "https://tandemtholdings.com/brand/tandem-t-logo.png";

    document.title = fullTitle;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement(attr === "content" ? "meta" : "link");
        if (selector.includes("property=")) {
          el.setAttribute("property", selector.match(/property="([^"]+)"/)[1]);
        } else if (selector.includes("name=")) {
          el.setAttribute("name", selector.match(/name="([^"]+)"/)[1]);
        } else if (selector.includes("rel=")) {
          el.setAttribute("rel", selector.match(/rel="([^"]+)"/)[1]);
        }
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', "content", desc);
    setMeta('link[rel="canonical"]', "href", canonical);
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[property="og:description"]', "content", desc);
    setMeta('meta[property="og:url"]', "content", canonical);
    setMeta('meta[property="og:image"]', "content", image);
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:description"]', "content", desc);
    setMeta('meta[name="twitter:image"]', "content", image);
  }, [title, description, path, ogImage]);
}
